


















import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Button from "@/components/Button/Button.vue";
import * as types from "@/store/constants/setting_types";
import rateUs from "@/utils/rate_us/rate_us";
import { isIos } from "@/utils/lodash";
import nativeStorage from "@/utils/nativeStorage/native_storage";

@Component({
  components: {
    Button
  }
})
export default class RateUsItem extends Vue {
  @Getter(types.GETTER_TAB_COIN_STORE_SETTINGS)
  private settingData: any;
  private hasRated: boolean = false;

  private isShowRateUs = false;

  get rateUsReward() {
    return this.settingData && this.settingData.rate_task && Object.keys(this.settingData.rate_task).length > 0
      ? this.settingData.rate_task.reward
      : 0;
  }

  // 必须监听settingData，getter不会随着settingData变化而触发
  @Watch("settingData")
  private onSettingDataChange(val: any) {
    this.judgeWhetherShowRateUs();
  }

  // 弹窗提示
  private showReminder() {
    const headerCustom: any = () => {
      const imgSrc = isIos()
        ? require("@/assets/icons-file/coins/pic_friendlyreminder_ios@3x.png")
        : require("@/assets/icons-file/coins/pic_friendlyreminder_android@3x.png");
      return <img style="width: 100%; height: 187px" src={imgSrc} />;
    };
    this.$_Dialog.show({
      headerCustom,
      title: "Friendly Reminder",
      content: {
        text:
          "Inappropriate review <%talking about rating for coins won't make you get reward coins./%> Other reviews are welcome!",
        highlightColor: "rgb(79, 121, 255)"
      },
      closable: true,
      closeOnClickModal: true,
      confirmBtn: {
        text: "I AGREE"
      },
      onConfirm: async (done: any) => {
        try {
          done();
          await rateUs(this.rateUsReward);
          this.hasRated = true;
          nativeStorage.set("isShowRateUs", false);
          this.judgeWhetherShowRateUs();
        } catch (error) {
          console.log("rate us error", error);
          if (typeof error === "object" && error.meta.error_message) {
            this.hasRated = true;
            nativeStorage.set("isShowRateUs", false);
            this.judgeWhetherShowRateUs();
          }
        }
      }
    });
  }

  private judgeWhetherShowRateUs() {
    const { rate_task } = this.settingData;
    this.isShowRateUs = !this.hasRated && Object.keys(rate_task).length > 0;
  }

  private async created() {
    this.hasRated = await nativeStorage.has("isShowRateUs");
    this.judgeWhetherShowRateUs();
  }
}
